'use strict';

angular.module('userRequestEditRoutes', [
    'userRequestEditControllers',
    'services.userAccessRequest',
    'services.businessSystem',
    'services.businessProcess',
    'services.employees'
])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider

    // By Request ID
    .state('userAccessRequest.edit', {
        url: '/{userAccessRequestId:int}?search&sameAsEmployeeId',
        params: {
            search: { value: '' },
            sameAsEmployeeId: { value: '' }
        },
        template: '<div ui-view></div>',
        resolve: {
            authenticatedUser: ['authenticatedUserService', function (service) {
                return service.getAuthenticatedUser();
            }],
            userRequest: ['userAccessRequestService', '$stateParams', function (service, $stateParams) {
                return service.getRequest($stateParams.userAccessRequestId);
            }],
            existingSysRoles: ['businessSystemService', 'userRequest', function (service, userRequest) {
                return service.getSystemRolesByEmployee(userRequest.EmployeeID);
            }],
            systemTypes: ['businessSystemService', function (service) {
                return service.getSystemTypes();
            }],
            businessProcesses: ['businessProcessService', function (service) {
                return service.getAllBusinessProcessesAndRelated();
            }],
            sameAsEmployee: ['employeeService', '$stateParams', function (service, $stateParams) {
                if ($stateParams.sameAsEmployeeId === '') return;
                return service.getEmployeeBasicInfos($stateParams.sameAsEmployeeId);
            }],
            sameAsSysRoles: ['editAccessRequestService', '$stateParams', function (service, $stateParams) {
                if ($stateParams.sameAsEmployeeId === '') return;
                return service.sameAs.getSystemRolesByEmployee($stateParams.userAccessRequestId, $stateParams.sameAsEmployeeId);
            }]
        },
        views: {
            '': {
                templateUrl: require('./Main.tpl.html'),
                controller: 'MainController'
            },
            'details@userAccessRequest.edit': {
                templateUrl: require('./GettingStarted.tpl.html'),
                controller: 'UserRequestGettingStartedController'
            },
            'sidebar@userAccessRequest.edit': {
                templateUrl: require('./SideBar.tpl.html'),
                controller: 'UserRequestSideBarController'
            },
            'task-cards@userAccessRequest.edit': {
                templateUrl: require('./TaskCards.tpl.html'),
                controller: 'TaskCardsController'
            }
        }
    })

    // By System Type for request
    .state('userAccessRequest.edit.networkShare', {
        url: '/systemType/NetworkShare',
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./ByNetworkShare.tpl.html'),
                controller: 'ByNetworkShareController',
                resolve: {
                    systemType: ['businessSystemService', '$stateParams', function (service) {
                        return service.getSystemTypeBySlug('NetworkShare');
                    }],
                    allowableSysRoles: ['businessSystemService', '$stateParams', 'systemType', function (service, $stateParams, systemType) {
                        return service.getAllowableSystemRolesByRequestAndSystemType($stateParams.userAccessRequestId, systemType.SystemTypeID);
                    }],
                    defaultEntitlementSysRoles: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                        return service.getDefaultEntitlementByRequest($stateParams.userAccessRequestId);
                    }]                    
                }
            }
        }
    })

    .state('userAccessRequest.edit.systemtype', {
        url: '/systemType/{slugSystemType}',
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./BySystemType.tpl.html'),
                controller: 'BySystemTypeController',
                resolve: {
                    systemType: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                        return service.getSystemTypeBySlug($stateParams.slugSystemType);
                    }],
                    allowableSysRoles: ['businessSystemService', '$stateParams', 'systemType', function (service, $stateParams, systemType) {
                        return service.getAllowableSystemRolesByRequestAndSystemType($stateParams.userAccessRequestId, systemType.SystemTypeID);
                    }],
                    defaultEntitlementSysRoles: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                        return service.getDefaultEntitlementByRequest($stateParams.userAccessRequestId);
                    }]
                }
            }
        }
    })

    // By Business Task for request
    .state('userAccessRequest.edit.taskcatalog', {
        url: '/taskCatalog',
        views: {
            'sidebar@userAccessRequest.edit': {
                templateUrl: require('./SideBarBusinessTasks.tpl.html'),
                controller: 'SideBarBusinessTasksController',
                resolve: {
                    businessTasks: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return [];
                    }],
                }
            },
            'details@userAccessRequest.edit': {
                templateUrl: require('./TaskCatalog.tpl.html'),
            }
        }
    })

    .state('userAccessRequest.edit.taskcatalog.businessactivity', {
        url: '/businessActivity/{businessActivityId:int}',
        views: {
            'sidebar@userAccessRequest.edit': {
                templateUrl: require('./SideBarBusinessTasks.tpl.html'),
                controller: 'SideBarBusinessTasksController',
                resolve: {
                    businessTasks: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return service.getBusinessTasksByBusinessActivity($stateParams.businessActivityId);
                    }],
                }
            }
        }
    })

    .state('userAccessRequest.edit.taskcatalog.businessactivity.businesstask', {
        url: '/businessTask/{businessTaskId:int}',
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./ByBusinessTask.tpl.html'),
                controller: 'ByBusinessTaskController',
                resolve: {
                    businessTask: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return service.getBusinessTaskByID($stateParams.businessTaskId);
                    }],
                    businessTasks: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return service.getBusinessTasksByBusinessActivity($stateParams.businessActivityId);
                    }],
                    businessTaskSystemRoles: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return service.getBusinessTaskSystemRoleByBusinessTaskID($stateParams.businessTaskId);
                    }],
                    allowableSysRoles: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                        return service.getAllowableSystemRolesByRequest($stateParams.userAccessRequestId);
                    }],
                    defaultEntitlementSysRoles: ['businessSystemService', '$stateParams', function (service, $stateParams) {
                        return service.getDefaultEntitlementByRequest($stateParams.userAccessRequestId);
                    }]
                }
            }
        }
    })

    // Location & Equipment
    .state('userAccessRequest.edit.locationEquipment', {
        url: '/locationEquipment',
        views: {
            'sidebar@userAccessRequest.edit': {
                templateUrl: require('./SideBarBusinessTasks.tpl.html'),
                controller: 'SideBarBusinessTasksController',
                resolve: {
                    businessTasks: ['businessProcessService', '$stateParams', function (service, $stateParams) {
                        return [];
                    }],
                }
            },
            'details@userAccessRequest.edit': {
                templateUrl: require('./LocationEquipment.tpl.html'),
                controller: 'LocationEquipmentController',
            }
        }
    })

    // Validation messages
    .state('userAccessRequest.edit.validationMessages', {
        url: '/validate',
        params: {
            checkSystemAccounts: { value: false }
        },
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./ValidationMessages.tpl.html'),
                controller: 'ValidationMessagesController',
                resolve: {
                    validationMessages: ['editAccessRequestService', '$stateParams', function (service, $stateParams) {
                        return service.request.validationMessages($stateParams.userAccessRequestId,
                                                                  $stateParams.checkSystemAccounts);
                    }]
                }
            }
        }
    })

    // Events
    .state('userAccessRequest.edit.events', {
        url: '/events',
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./DisplayEvents.tpl.html'),
                controller: 'DisplayEventsController',
                resolve: {
                    events: ['editAccessRequestService', '$stateParams', function (service, $stateParams) {
                        return service.request.events($stateParams.userAccessRequestId);
                    }]
                }
            }
        }
    })

    // Arrival Information
    .state('userAccessRequest.edit.arrivalInformation', {
        url: '/events',
        views: {
            'details@userAccessRequest.edit': {
                templateUrl: require('./DisplayArrivalInformation.tpl.html'),
                controller: 'DisplayArrivalInformationController'
            }
        }
    })
}]);